/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-19 10:15:07
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-06-21 18:36:20
 * @FilePath: /dsicm-admin-web/src/views/treatment/api/index.js
 */
import request from '@/utils/req.js';

//入案管理分页列表头部筛选条件
export function apiGetWholeCourse(params) {
    return request.post("/admin/whole-course/v2/page", params);
}
// 记录切换服务
export function updatePatientGroup(params) {
    return request.put("/admin/patient/updatePatientGroupCodeByPatientId?patientId=" + params.patientId + "&wholeCourseId=" + params.wholeCourseId + "&groupCode=" + params.groupCode, {});
}
//获取线下机构
export function apiDepartmentScreen(params) {
    return request.post("/admin/hospital/listPullDown", params);
}
//进入问诊房间 (获取房间问诊状态)
export function apiIntoInquiryRoom(params) {
    return request.post("/admin/inquiry-info/intoInquiryRoom", params);
}

//患者全病程处理接口
export function apiWholeCourseHandler(params) {
    return request.get(`/admin/whole-course/handler/${params}`);
}
//获取历史消息列表
export function apiGgetRecordByRoomCode(params) {
    return request.post("/admin/chat-record/getRecordByRoomCode", params);
}
///疾病类型列表查询
export function apiDiseaseType(params) {
    return request.get("/admin/disease-type", params);
}
//任务提醒分页列表适配admin2.0页面接口
export function apiCaseMgrTaskPage(params) {
    return request.post("/admin/case-mgr-task/v2/page", params);
}

//反馈处理分页列表适配admin2.0页面接口
export function apiFeedbackPage(params) {
    return request.post("/admin/feedback/v2/page", params);
}
///
//反馈处理分页列表适配admin2.0页面接口
export function apiPatientFiles(params) {
    return request.post("/admin/patient-files/v2/page", params);
}
//打卡异常分页列表适配admin2.0页面接口
export function apiPatientTask(params) {
    return request.post("/admin/patient-task/v2/page", params);
}
//单个患者任务接口admin2.0
export function apiGetByWholeCourseId(params) {
    // return request.post(`/admin/patient-task/getByWholeCourseId?status=${params.status}&wholeCourseId=${params.wholeCourseId}`);
    return request.get(`/admin/patient-task/getPatientTaskAbnormal/${params.wholeCourseId}`)
}
//新版ui界面个案任务接口
export function apiCaseGetByWholeCourseId(params) {
    return request.post(`/admin/case-mgr-task/getByWholeCourseId?wholeCourseId=${params}`);
}
//查询问诊列表-admin,新ui 专项对话
export function apiGetInquiryPageOnAdmin(params) {
    return request.post(`/admin/inquiry-info/getInquiryPageOnAdmin`, params);
}

// 查询医护对话左侧患者列表
export function apiGetDoctorNursePageOnAdmin(params) {
    return request.post(`/admin/patient-doctor-confirm/doctorNurse/page`, params);
}

//获取当前个案所在个案组ID
export function apiGetCaseMgrGroupId(params) {
    return request.get("/admin/user-info/getCaseMgrGroupId", params);
}

//发送续约提醒
export function sendRenewalReminder(params) {
    return request.get("/admin/whole-course/sendRenewalReminder", params);
}

// 患者反馈评估问卷
export function getPatientFeedbackByWholeCourseId(params) {
    return request.post('/admin/feedback/getPatientFeedbackByWholeCourseId', params);
}

// 反馈评估问卷发送
export function sendFeedback(feedbackId) {
    return request.post(`/admin/feedback/sendFeedback/${feedbackId}`);
}

// 获取问卷详情
export function getAnswerSheetLog(params) {
    return request.get("/admin/qs-answer-sheet/getAnswerSheetLog", params);
}

// 关闭数据异常提醒
export function patientAnomalyClose(params) {
    return request.put("/admin/patient-anomaly", params);
}

// 设置自定义名称
export function setCustomName(params) {
    return request.get("/admin/chat-record/setCustomName", params);
}

// 获取下一张图片
export function nextImage(params) {
    return request.get("/admin/chat-record/nextImage", params);
}

// 获取上一张图片
export function preImage(params) {
    return request.get("/admin/chat-record/preImage", params);
}
export function sendTimMessage(params) {
    return request.post('/admin/chat-room/sendTimMessage', params);
}

// 发送续约当前
export function reportOrderPush(params) {
    return request.post('/admin/order-whole-course-detail/repeat-order/push', params);
}


// 服务推送列表
export function teamServicePage(params) {
    return request.post("/admin/team-service/page", params);
}
// 服务推送
export function teamServicePush(params) {
    return request.post("/admin/team-service/push", params);
}
// 落地页推送列表
export function landeImPage(params) {
    return request.post("/admin/landing-page/im-page", params);
}
// 落地页推送
export function landImPush(params) {
    return request.post("/admin/landing-page/batch-push", params);
}

// 疗程管理和病人管理右侧数据新接口
export function getPatientDetailedInformationVO(params) {
    return request.post("/admin/patient/getPatientDetailedInformationVO", params);
}
//新版患者档案基本信息更新按钮
export function UpdatepatientArchiesLeft(params) {
    return request.post(`/admin/patient-archives/UpdatepatientArchiesLeft`, params);
}
//获取职业
export function getProfession() {
    return request.get("/admin/category/profession/children");
}

// 服务列表
export function getServeNameByPatientId(params) {
    return request.get("/admin/whole-course/getServeNameByPatientId", params);
}
//新版患者档案病历更新按钮
export function UpdatepatientArchiesRight(params) {
    return request.post(`/admin/patient-archives/UpdatepatientArchiesRight`, params);
}
// icd-10数据查询接口
export function getFindIcdDiseaseByCondition(params) {
    return request.get("/dsicm-data-base/feign/disease-type/findIcdDiseaseByCondition", params)
}
export function patientArchivesAssistedReproduction(params) {
    return request.post("/dsicm-api/feign/patient-archives-assisted-reproduction", params)
}

// 疗程管理-重点指标月度评估
export function getPatientBmiByPatientOrderByMonth(params) {
    return request.post("/admin/patient-bmi/getPatientBmiByPatientOrderByMonth", params)
}

// 生化指标
export function getPatientDiseaseInspectionLogList(params) {
    return request.post("/admin/disease-inspection/getDiseaseInspectionLogListForReport", params)
}

// 疗程管理-发送重点指标
export function sendMonthedIndicatorReport(params) {
    return request.post("/admin/key-indicator-report/sendMonthedIndicatorReport", params)
}

// 关联至编链
export function linkToScheme(params) {
    return request.post("/dsicm-api/feign/scheme-time-axis/linkToScheme", params)
}

// 查患者当前生效链的所有时间轴
export function getListByPatientId(params) {
    return request.get("/dsicm-api/feign/scheme-time-axis/getListByPatientId", params)
}

// 获取战略病种列表  
export function getStrategicDiseaseAndWechat(params) {
    return request.get("/patient/disease-following/getStrategicDiseaseAndWechat", params)
}

// 获取战略病种治疗阶段
export function getTherapyStageByDiseaseId(params) {
    return request.get("/admin/disease-following/getTherapyStageByDiseaseId", params)
}

// 获取关联推送健康推荐
export function gethealthRecommendData(params) {
    return request.post("/admin/relate-push/gethealthRecommendData", params)
}
// 获取患者全病程id
export function getPatientWholeCourseId() {
    return request.get("/admin/patient/findPatientLatestWholeCourseId", {})
}
// 复诊计划
export function getReturnVisitPlan(params) {
    return request.get(`/admin/patient-task/getReturnVisitPlanTaskByRefId/${params}`, {})
}
// 未读列表
export function getUnreadList(params) {
    return request.get(`/admin/whole-course/getUnreadSignServeListByPatientId?patientId=${params.patientId}&customerService=${params.customerService}`, {})
}
//标记
export function setUnreadSign(params) {
    if (params.id) {
        return request.post(`/admin/chat-room/setUnreadSign?groupCode=${params.imId}&customerService=${params.customerService}&wholeCourseId=${params.id}`, {})
    } else {
        return request.post(`/admin/chat-room/setUnreadSign?groupCode=${params.imId}&customerService=${params.customerService}`, {})
    }
}
// 更新房间未读记录
export function deleteRecordByGroupCode(params) {
    return request.post(`/admin/chat-room-unread-record/deleteRecordByGroupCode`, params)
}
// 搜索渠道
export function followingChannel(params) {
    return request.post(`/admin/patient-channel-following/page`, params)
}
// 搜索标签
export function followingTag(params) {
    return request.get(`/admin/patient-label/id-name-list`, params)
}
// 搜索合作机构
export function followingCooperateOrg(params) {
    return request.post(`/admin/org-channel/search`, params)
}
// 搜索关注病种
export function followingDisease(params) {
    return request.post(`/admin/disease-following/all`, params)
}
// 搜索服务团队
export function followingTeam(params) {
    return request.post(`/admin/doctor-team/page`, params)
}
// 搜索服务
export function followingService(params) {
    return request.post(`/admin/patient-scheme/simplePage`, params)
}
// 搜索服务来源
export function followingSource(params) {
    return request.get(`/admin/whole-course/serviceSources`, params)
}

//获取所有地区列表
export function regionAll(params) {
    return request.get(`/patient/region/all`, params)
}
//获取健康档案图片列表
export function getFileUrls(params) {
    return request.get(`/admin/archives-event/getPatientFileItemsUrlsByPatientFilesId?patientFilesId=${params}`, {})
}

// 根据id 和类型 查询详情
export function getTaskById(params) {
    return request.get(`/admin/patient-task/getTaskById`, params)
}

// 查询患者标签 
export function getListPatientLabelByStatus(params) {
    return request.get(`/admin/patient-label/listPatientLabelByStatus`, params)
}

export function getPatientDiseaseCaseInfo(patientId) {
    return request.get(`/biz/patient-disease-case-info/getPatientDiseaseCaseInfo/${patientId}`)
}

export function patientTopUp(params) {
    return request.post(`/admin/whole-course/patientTop`, params)
}
